<template>
  <div class="btn-rate-generation">
    <span class="btn" @click="vGenereTarif">
      <span class="btn-libelle">{{$_('i_show_my_rates').toUpperCase()}}</span>
      <span v-if="loading" class="btn-loader"></span>
    </span>
  </div>
</template>

<script>
import rateService from "../services/rateService";

export default {
  name: "RateButton",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    vGenereTarif() {
      this.loading = true;
      rateService
        .getRate()
        .then(res => {
          if (res.data.PNLOT !== undefined) {
            this.$store.dispatch("tarif/SELECT", {
              key: "pnlot",
              value: res.data.PNLOT
            });
          }
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.btn-rate-generation {
  display: inline-flex;
  margin-right: 15px;
}
.btn-loader {
  width: 15px;
  height: 15px;
  border: solid 2px #fff;
  border-radius: 50%;
  display: inline-block;
  border-bottom-color: transparent;
  animation: rotate 0.6s infinite linear;
  margin-left: 15px;
}
.btn {
  display: inline-flex;
  align-items: center;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>